import { render, staticRenderFns } from "./CurrentClientStatisticModal.vue?vue&type=template&id=e660367c&scoped=true"
import script from "./CurrentClientStatisticModal.vue?vue&type=script&lang=js"
export * from "./CurrentClientStatisticModal.vue?vue&type=script&lang=js"
import style0 from "./CurrentClientStatisticModal.vue?vue&type=style&index=0&id=e660367c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e660367c",
  null
  
)

export default component.exports